import { c as I } from "react/compiler-runtime";
import { useRef as d, useEffect as B } from "react";
function w(e, n = !1) {
  const o = Intl.NumberFormat("en", {
    notation: "compact"
  }), r = n ? Math.abs(e) : e;
  return o.format(r);
}
const F = "MMM DD, YYYY | hh:mmA";
async function S(e) {
  if (navigator?.clipboard)
    return navigator.clipboard.writeText(e);
}
function T(e, n) {
  const o = e.length;
  if (o === 0)
    return -1;
  let r = 0, t = o - 1;
  const i = o > 1 ? e[1] - e[0] : 0;
  if (n < e[0] - i || n > e[o - 1] + i)
    return -1;
  for (; r <= t; ) {
    const c = Math.floor((r + t) / 2), l = e[c];
    if (l < n)
      r = c + 1;
    else if (l > n)
      t = c - 1;
    else
      return c;
  }
  return Math.abs(e[r] - n) < Math.abs(e[t] - n) ? r : t;
}
const _ = (e, n = 18) => e.length > n ? e.slice(0, n) + " ..." : e;
function N(e) {
  if (e < 1) return {
    value: e,
    unit: "Bytes"
  };
  if (e === 1) return {
    value: 1,
    unit: "Byte"
  };
  const n = 1024, o = ["Bytes", "KB", "MB", "GB", "TB"], r = Math.floor(Math.log(e) / Math.log(n));
  return {
    value: parseFloat((e / Math.pow(n, r)).toFixed(2)),
    unit: o[r]
  };
}
function Y(e) {
  return Number.isInteger(e) ? String(e) : e.toFixed(2);
}
function D(e, n, o, r) {
  const t = I(14), i = o === void 0 ? !1 : o;
  let c;
  t[0] !== r ? (c = r === void 0 ? [] : r, t[0] = r, t[1] = c) : c = t[1];
  const l = c, u = d(b), s = d(null);
  let f;
  t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = function() {
    s.current !== null && (clearInterval(s.current), s.current = null);
  }, t[2] = f) : f = t[2];
  const p = f;
  let a, m;
  t[3] !== e ? (a = () => {
    u.current = e;
  }, m = [e], t[3] = e, t[4] = a, t[5] = m) : (a = t[4], m = t[5]), B(a, m);
  let h;
  t[6] !== n || t[7] !== i ? (h = () => {
    if (n === null) {
      p();
      return;
    }
    const M = async () => {
      u.current && await u.current();
    };
    return i && M(), s.current = window.setInterval(M, n), () => p();
  }, t[6] = n, t[7] = i, t[8] = h) : h = t[8];
  let g;
  t[9] !== n || t[10] !== l || t[11] !== i ? (g = [n, i, ...l], t[9] = n, t[10] = l, t[11] = i, t[12] = g) : g = t[12], B(h, g);
  let v;
  return t[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = {
    ClearInterval: p
  }, t[13] = v) : v = t[13], v;
}
function b() {
}
const E = (e) => {
  let n, o, r;
  if (e?.startsWith("#")) {
    const i = parseInt(e.slice(1), 16);
    n = i >> 16 & 255, o = i >> 8 & 255, r = i & 255;
  } else {
    const c = document.createElement("canvas").getContext("2d");
    if (c) {
      c.fillStyle = e;
      const u = c.fillStyle.match(/\d+/g);
      if (u)
        [n, o, r] = u.map(Number);
      else
        return 1;
    } else
      return 1;
  }
  return (0.2126 * n + 0.7152 * o + 0.0722 * r) / 255;
};
export {
  F as DateTimeFormat,
  S as copyToClipBoard,
  w as formatCompactNumber,
  Y as formatNumber,
  N as getFormattedBytes,
  E as getTextColorFromBackground,
  T as getTimelineIndex,
  _ as truncateString,
  D as useInterval
};
